import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

const FallbackError = ({ resetErrorBoundary }: FallbackProps): JSX.Element => {
  const { pathname } = useLocation();
  const [originalPath] = useState(pathname);

  useEffect(() => {
    if (pathname !== originalPath) {
      resetErrorBoundary();
    }
  }, [originalPath, pathname, resetErrorBoundary]);

  return (
    <div>
      <Typography variant="h2">Something went wrong.</Typography>
    </div>
  );
};

export { FallbackError };
